import { useQueryClient } from '@tanstack/react-query'
import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'

import { useAuth } from '@/context/AuthContext'
import { clearImpersonation } from '@/lib/impersonation'
import { clearAuthTokens, unregisterNativePush } from '@/lib/native'
import { QUERY_KEYS } from '@/lib/queryKeys'

export function useLogout() {
  const queryClient = useQueryClient()
  const { setIsAuthenticated } = useAuth()
  const navigate = useNavigate()
  return useCallback(async () => {
    clearImpersonation()
    await unregisterNativePush()
    await clearAuthTokens()
    setIsAuthenticated(false)
    queryClient.setQueryData([QUERY_KEYS.LOGGED_USER], null)
    queryClient.clear()
    navigate('/')
  }, [navigate, queryClient, setIsAuthenticated])
}
